import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }

  textarea {
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 4px;
    color: #dee2e6;
    background: #323a4e;
    padding: 10px 20px;
    height: 152px;
    width: 100%;
    resize: none;
    margin-top: 0.8rem;
  }

  label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  /* Parte responsiva */
  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

export const Button = styled.button.attrs({
  type: 'submit',
})`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  margin-top: 20px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }
`;

export const Label = styled.div`
  > span {
    color: #e0042d;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.3;
    width: 100%;
    margin: 0.6rem 0 0.4rem;
    border-radius: 4px;
    transform: none;
    animation: fadeIn 350ms ease-in-out 1;
    @keyframes fadeIn {
      from {
        transform: translateY(-20px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
`;

export const Ward = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ImagemInput = styled.label`
  width: 230px;
  height: 150px;
  border: 1px dashed #fff;
  border-radius: 4px;
  cursor: ${props => (props.size >= 6 ? 'not-allowed' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s;
  input {
    display: none;
  }

  &:hover {
    opacity: 0.4;
  }
`;

export const BoxImagem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 24px;
  }
`;

export const Imagem = styled.button`
  background: none;
  border: 0;
  padding: 0;

  img {
    width: 230px;
    height: 150px;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
`;

export const Table = styled.table`
  background: #2a3142;
  flex: 1;
  width: 100%;
  text-align: left;
  border-collapse: collapse;

  th {
    padding: 20px 0;

    & + th {
      text-align: right;
    }
  }

  td {
    padding: 15px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.17);

    & + td {
      text-align: right;
    }
  }
`;

export const Menus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const Buscar = styled.input`
  margin: 10px;
  padding: 10px 8px;
  border-radius: 4px;
  border: 0;
  color: rgba(255, 255, 255, 0.7);
  background: #323a4e;

  &::placeholder {
    color: rgba(255, 255, 255, 0.19);
  }
`;

export const BtAcao = styled.button`
  background: ${props => (props.inativo === 1 ? '#ec4561' : '#626ed4')};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 7px 15px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  ${props =>
    props.inativo === 1
      ? css`
          &:hover {
            background: ${darken(0.04, '#ec4561')};
          }
        `
      : css`
          &:hover {
            background: ${darken(0.04, '#626ed4')};
          }
        `}

  & + button {
    margin-left: 10px;
  }
`;

export const Block = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const NewButton = styled.button`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }

  svg {
    margin-right: 5px;
  }
`;

export const PageActions = styled.div`
  padding-top: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  button {
    transition: opacity 0.25s ease-out;
    background: #626ed4;
    color: #fff;
    border-radius: 4px;
    outline: 0;
    border: 0;
    padding: 8px;
    &:disabled {
      opacity: 0.35;
      cursor: not-allowed;
    }
  }

  span {
    padding: 0 10px;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  text-align: center;

  span {
    color: #fff;
    padding: 10px 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

export const ModalMenus = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    flex: 1;
    background: #626ed4;
    border: 0;
    padding: 15px 0;
    border-radius: 4px;
    color: #fff;

    & + button {
      margin-left: 10px;
      background: #ec4561;
    }
  }
`;

export const SemDados = styled.div`
  padding: 40px 0;
  display: flex;
  justify-content: center;

  h2 {
    color: rgba(255, 255, 255, 0.19);
  }
`;

export const FormInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
`;

export const Etapas = styled.div`
  display: flex;
  margin: 22px 0;
  width: 48%;
  flex-direction: column;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const EtapasHead = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px dashed #c9c9c9;
  justify-content: space-between;
`;

export const EtapasInner = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  width: 100%;
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 12px 0;
`;

export const EtapasTop = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
`;

export const EtapasImg = styled.div`
  display: flex;
  width: 50%;
  justify-content: space-around;
  align-items: center;
`;
export const EtapasInput = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: center;

  & label {
    display: flex;
    width: 100%;
  }
`;
